exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buyer-order-history .ivu-modal{position:relative;width:80%!important;max-width:1200px;min-width:900px;top:30px}.buyer-order-history .ivu-modal-body{padding:0;max-height:none;height:calc(100vh - 160px)}.buyer-order-history .modal-body-main{padding:16px}.buyer-order-history .page-loading{position:sticky;height:calc(100vh - 160px);top:0;z-index:999999999}", ""]);

// exports
